module.exports = __webpack_public_path__ + "images/district_back.1782880901430.png";